import React from 'react';
import Footer from '../../layouts/MainFrame/Footer/Footer';
import { styled } from '@mui/material';

const StyledWrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignContent: 'stretch',
    alignItems: 'flex-start',
    height: '100%'
}));

const StyledPageWrapper = styled('div')(({ theme }) => ({
    width: 'calc(100% - 30px)',
    order: '1',
    flex: '1 1 auto',
    alignSelf: 'center',
    marginInline: '15px',
    [theme.breakpoints.down("sm")]: {
        width: 'calc(100% - 10px)',
    },
}));

export const PageWrapper: React.FC<{ children?: React.ReactNode }> = (
    props
) => {
    return (
        <StyledWrapper>
            <StyledPageWrapper>{props.children}</StyledPageWrapper>
        </StyledWrapper>
    );
};
